const gradeLevels = ["06", "07", "08", "09", "10", "11", "12"];

export default gradeLevels;
